let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l0xvE")).then(() => parcelRequire('6eUFQ'));